angular.module('tradersyard').factory('MeetingManagerFactory', [
    '$rootScope',
    '$rootScope',
    'graph-meeting-factory',
    'MessageManagerFactory',
    'WebSocket',
    '$timeout',
    'GraphTitleFactory',
    '$location',
    '$socket',

    function (
        $rootScope,
        $scope,
        ApiMeetingFactory,
        MessageManagerFactory,
        WebSocket,
        $timeout,
        GraphTitleFactory,
        $location,
        $socket
    ) {
        function Instance() {
            var instance = this;

            function Sucess(response) {
                return response.data.state === 0 && response.data.data.length > 0;
            }

            function parseUrlMeetingId() {
                var path = $location.path();
                var matches = path.match(/\/meeting\/([0-9]+)$/i);
                return matches !== null ? parseInt(matches[1]) : null;
            }

            function setUrlMeetingId(id) {
                $location.path('/meeting/' + id);
                $location.replace();
            }

            instance.Data = [{ id: 0, name: 'Public Chat' }];
            instance.Guid = undefined;
            instance.Current = undefined;
            instance.Message = undefined;
            instance.Focus = false;
            instance.Let = 0;
            instance.Lock = 0;
            instance.Page = 0;
            instance.Glue = true;
            instance.Unreaded = 0;
            instance.entryId = null;

            ApiMeetingFactory.entry('user', 'me')
                .unread({ params: { limit: 5 } })
                .then(function (response) {
                    if (response.data.state === 0) {
                        instance.Unreaded = response.data.total;
                        GraphTitleFactory.setMissValue(instance.Unreaded);
                    }
                });

            instance.SetEntryId = function (entryId) {
                instance.entryId = entryId;
            };

            instance.Touch = function () {
                // if (instance.Focus === true) {
                if (instance.Current.unread === true) {
                    --instance.Unreaded;
                    GraphTitleFactory.setMissValue(instance.Unreaded);
                    instance.Current.unread = false;
                }

                instance.Message.Touch(instance.Current);
                // }
            };

            instance.Add = function (meeting) {
                ++instance.Let;
                instance.Data.unshift(meeting);

                return instance;
            };

            instance.Concat = function (data) {
                instance.Data = instance.Data.concat(data);

                return instance;
            };

            instance.Digest = function () {
                if (!$scope.$$phase) {
                    $scope.$digest();
                }

                return instance;
            };

            instance.Select = function (meeting) {
                instance.Current = meeting;

                if ($scope.$rootScope.isRootMeetingPage === true) {
                    setUrlMeetingId(meeting.id);
                }

                $rootScope.$broadcast('meeting:change');

                // if (instance.DoFocus) {
                //     instance.DoFocus();
                //     instance.Focus = true;
                // }

                if (instance.Message === undefined || instance.Message.Id !== meeting.id) {
                    instance.Message = MessageManagerFactory.Get(meeting.id, 'meeting', $scope);

                    setTimeout(function () {
                        $scope.$digest();
                    });
                }
            };

            instance.Query = function (next) {
                if (instance.Lock === 0) {
                    instance.Lock = 1;
                    ++instance.Page;

                    ApiMeetingFactory.entry('user', 'me')
                        .query({
                            params: {
                                limit: 100,
                                page: instance.Page,
                                let: instance.Let,
                            },
                        })
                        .then(function (response) {
                            if (Sucess(response) === true) {
                                response.data.data.concat(response.data.data).filter(function (item) {
                                    var itemInData =
                                        instance.Data.filter(function (meeting) {
                                            return parseInt(meeting.id) === parseInt(item.id);
                                        }).length > 0;

                                    if (!itemInData) {
                                        $socket.emit('join:meeting', [item.id]);
                                        instance.Data.push(item);
                                    }
                                });

                                if (instance.Message === undefined) {
                                    var queueId = parseUrlMeetingId();

                                    if (queueId !== null) {
                                        var iteration = true;
                                        response.data.data.forEach(function (meeting, index) {
                                            if (parseInt(meeting.id) === queueId) {
                                                instance.Select(meeting);
                                                iteration = false;
                                            } else if (index + 1 >= response.data.data.length && iteration === true) {
                                                if (instance.Page < response.data.data) {
                                                    instance.Lock = 0;
                                                    if (next) next();
                                                    instance.Query();
                                                } else {
                                                    instance.Select(instance.Data[0]);
                                                }
                                            }
                                        });
                                    } else {
                                        //instance.Select(instance.Data.length > 1 && instance.Data[0].id === 0 ? instance.Data[1] : instance.Data[0]);
                                        instance.Select(instance.Data[0]);
                                    }
                                }

                                instance.Lock = 0;
                            } else {
                                instance.Select({ id: 0, name: 'Public Chat' });
                            }

                            if (next) next();
                        });
                }
            };

            // we are querying meetings here and we connect on message:create for something...
            //
            WebSocket.on('message:create', function (data) {
                var exists = false,
                    position = 0;

                angular.forEach(instance.Data, function (meeting, i) {
                    if (parseInt(meeting.id) === parseInt(data.place.id) && data.place.name === 'meeting') {
                        exists = true;
                        position = i;
                    }
                });

                $timeout(function () {
                    // somehow you can receive a message from a meeting that you dont have on the list?
                    // So how did you joined the socket.io that delivers this message?
                    if (exists === false) {
                        ApiMeetingFactory.entry('user', 'me')
                            .read(data.place.id)
                            .then(function (response) {
                                if (Sucess(response) === true) {
                                    instance.Add(response.data.data).Digest();
                                }
                            });
                    } else {
                        // this moves meetings with new messages to top?
                        var meeting = instance.Data[position];
                        var unread = meeting.unread;
                        meeting.unread =
                            data.node.owner.id !== $scope.me.id &&
                            (instance.Current.id !== meeting.id ||
                                (instance.Current.id === meeting.id && instance.Focus === false));

                        if (unread !== meeting.unread) {
                            if (meeting.unread === true) {
                                ++instance.Unreaded;
                                GraphTitleFactory.setMissValue(instance.Unreaded);
                            } else {
                                --instance.Unreaded;
                                GraphTitleFactory.setMissValue(instance.Unreaded);
                            }
                        }

                        let newPosition = instance.entryId === meeting.id || !instance.entryId ? 1 : 2;

                        if (meeting.id > 0) {
                            instance.Data.splice(newPosition, 0, instance.Data.splice(position, 1)[0]);
                        }

                        data.node.unread =
                            data.node.owner.id !== $scope.me.id &&
                            instance.Current.id !== meeting.id &&
                            instance.Focus === false;

                        meeting.message = data.node;

                        if (instance.Focus === true) {
                            instance.Message.Touch(instance.Current);
                        }

                        instance.Digest();
                    }
                }, 0);
            });

            WebSocket.on('message:update', function (data) {
                var exists = false,
                    position = 0;

                angular.forEach(instance.Data, function (meeting, i) {
                    if (parseInt(meeting.id) === parseInt(data.place.id) && data.place.name === 'meeting') {
                        exists = true;
                        position = i;
                    }
                });

                $timeout(function () {
                    if (exists === true) {
                        var message = instance.Data[position].message;

                        if (message && parseInt(message.id) === parseInt(data.node.id)) {
                            instance.Data[position].message = data.node;
                        }
                    }
                }, 0);
            });

            WebSocket.on('message:delete', function (data) {
                var exists = false,
                    position = 0;

                angular.forEach(instance.Data, function (meeting, i) {
                    if (parseInt(meeting.id) === parseInt(data.place.id) && data.place.name === 'meeting') {
                        exists = true;
                        position = i;
                    }
                });

                $timeout(function () {
                    if (exists === true) {
                        var message = instance.Data[position].message;

                        if (message && parseInt(message.id) === parseInt(data.node.id)) {
                            var length = instance.Message.Data.length - 1;

                            if (length > 1) {
                                instance.Data.message = instance.Message.Data[length - 1];
                            }
                        }
                    }
                }, 0);
            });

            WebSocket.on('meeting:contact_status', function (data) {
                var exists = false,
                    position = 0;
                angular.forEach(instance.Data, function (meeting, i) {
                    if (parseInt(meeting.id) === parseInt(data.place.id) && data.place.name === 'meeting') {
                        instance.Data[i].can_publish = data.can_contact;
                        instance.Digest();
                    }
                });
            });

            WebSocket.on('me:meeting:invite', function (data) {
                var messageContent = angular.extend({}, data.node, {
                    type: 'meeting.invite',
                });

                $rootScope.$broadcast('graph-modal-show', {
                    title: 'Web Meeting Invitation',
                    type: 'meeting.invite',
                    content: messageContent,
                });
            });

            WebSocket.on('me:friend:friend', function (data) {
                ApiMeetingFactory.friend(data.node.id).then(function (response) {
                    if (response.data.state === 0) {
                        var endIndex = instance.Data.length - 1;
                        var mtExists = false;
                        var mtObject;
                        var mtPosits = -1;
                        instance.Data.forEach(function (meeting, i) {
                            if (parseInt(meeting.id) === parseInt(response.data.data.id)) {
                                mtExists = true;
                                mtPosits = i;
                            }

                            if (i === endIndex) {
                                if (mtExists === false) {
                                    instance.Add(response.data.data);
                                    setTimeout(instance.Digest, 0);
                                } // else just leave the meeting where it is
                            }
                        });
                    }
                });

                // request meeting and push into top
                // var exists = false, position = 0;
                // angular.forEach(instance.Data, function (meeting, i) {
                //     if (parseInt(meeting.id) === parseInt(data.place.id) && data.place.name === 'meeting') {
                //         instance.Data[i].can_publish = data.can_contact;
                //         instance.Digest();
                //     }
                // });
            });
        }

        var singleton;

        return {
            Singleton: function () {
                if (singleton === undefined) {
                    singleton = new Instance();
                    return singleton;
                } else {
                    return singleton;
                }
            },
            Instance: function () {
                return new Instance();
            },
        };
    },
]);
